import { render, staticRenderFns } from "./coreDataStatistics.vue?vue&type=template&id=cf9d56e0&scoped=true"
import script from "./coreDataStatistics.vue?vue&type=script&lang=js"
export * from "./coreDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./coreDataStatistics.vue?vue&type=style&index=0&id=cf9d56e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9d56e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9d56e0')) {
      api.createRecord('cf9d56e0', component.options)
    } else {
      api.reload('cf9d56e0', component.options)
    }
    module.hot.accept("./coreDataStatistics.vue?vue&type=template&id=cf9d56e0&scoped=true", function () {
      api.rerender('cf9d56e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAdmin/coreDataStatistics.vue"
export default component.exports